import React from 'react';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { seitenListe } from '../../../lib/immobilien/seiten';

/**
 * Seitennavigation für lange Listen: „21–40 von 683“ links, ‹ 1 … 4 5 6 … 35 › rechts.
 * Aktive Seite in --acc-fill (wie das aktive Segment), sonst --fill2.
 */
export function Seitennavigation({ seite, seiten, von, bis, gesamt, onSeite, einheit = 'Einträge' }: {
  seite: number;
  seiten: number;
  von: number;
  bis: number;
  gesamt: number;
  onSeite: (seite: number) => void;
  /** z. B. „Mieter“ */
  einheit?: string;
}) {
  const knopf = (an: boolean): React.CSSProperties => ({
    minWidth: 34, height: 34, padding: '0 10px', borderRadius: 17, border: 'none', fontSize: 13, fontWeight: 700,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    background: an ? 'var(--acc-fill)' : 'var(--fill2)', color: an ? 'var(--acc-ink)' : 'var(--ink)', boxShadow: an ? 'var(--acc-sh)' : 'none',
  });
  return (
    <nav aria-label="Seiten" className="flex items-center justify-between flex-wrap" style={{ gap: 10 }}>
      <span className="immo-zahl" style={{ fontSize: 13, color: 'var(--ink3)' }}>{von}–{bis} von {gesamt} {einheit}</span>
      {seiten > 1 && (
        <div className="flex items-center flex-wrap" style={{ gap: 6 }}>
          <button type="button" aria-label="Vorherige Seite" disabled={seite <= 1} onClick={() => onSeite(seite - 1)}
            className={seite <= 1 ? 'cursor-not-allowed' : 'immo-hover-flaeche cursor-pointer'} style={{ ...knopf(false), opacity: seite <= 1 ? 0.45 : 1 }}>
            <CaretLeft weight="bold" size={13} />
          </button>
          {seitenListe(seite, seiten).map((n, i) => n === 'luecke'
            ? <span key={`l${i}`} aria-hidden style={{ minWidth: 20, textAlign: 'center', color: 'var(--ink3)' }}>…</span>
            : (
              <button key={n} type="button" aria-label={`Seite ${n}`} aria-current={n === seite ? 'page' : undefined} onClick={() => onSeite(n)}
                className={`immo-zahl cursor-pointer ${n === seite ? '' : 'immo-hover-flaeche'}`} style={knopf(n === seite)}>
                {n}
              </button>
            ))}
          <button type="button" aria-label="Nächste Seite" disabled={seite >= seiten} onClick={() => onSeite(seite + 1)}
            className={seite >= seiten ? 'cursor-not-allowed' : 'immo-hover-flaeche cursor-pointer'} style={{ ...knopf(false), opacity: seite >= seiten ? 0.45 : 1 }}>
            <CaretRight weight="bold" size={13} />
          </button>
        </div>
      )}
    </nav>
  );
}
